export class AppRoutes {
  
  public static USER_PROFILE: string = '/app/home/profile'
  public static ALL_GAMES: string = '/app/home/all-games/'
}